__turbopack_export_value__({
  "body-logo-18": "DoctorsSlider-module-scss-module__Ft2KZa__body-logo-18",
  "body-text-12": "DoctorsSlider-module-scss-module__Ft2KZa__body-text-12",
  "body-text-14": "DoctorsSlider-module-scss-module__Ft2KZa__body-text-14",
  "body-text-16": "DoctorsSlider-module-scss-module__Ft2KZa__body-text-16",
  "body-text-18": "DoctorsSlider-module-scss-module__Ft2KZa__body-text-18",
  "body-text-20": "DoctorsSlider-module-scss-module__Ft2KZa__body-text-20",
  "body-text-24": "DoctorsSlider-module-scss-module__Ft2KZa__body-text-24",
  "body-text-24-2": "DoctorsSlider-module-scss-module__Ft2KZa__body-text-24-2",
  "body-text-heading-2": "DoctorsSlider-module-scss-module__Ft2KZa__body-text-heading-2",
  "body-text-heading-3": "DoctorsSlider-module-scss-module__Ft2KZa__body-text-heading-3",
  "body-text-medium-14": "DoctorsSlider-module-scss-module__Ft2KZa__body-text-medium-14",
  "body-text-medium-16": "DoctorsSlider-module-scss-module__Ft2KZa__body-text-medium-16",
  "body-text-medium-18": "DoctorsSlider-module-scss-module__Ft2KZa__body-text-medium-18",
  "body-text-medium2-18": "DoctorsSlider-module-scss-module__Ft2KZa__body-text-medium2-18",
  "body-text2-14": "DoctorsSlider-module-scss-module__Ft2KZa__body-text2-14",
  "body-text2-16": "DoctorsSlider-module-scss-module__Ft2KZa__body-text2-16",
  "button-primary-text": "DoctorsSlider-module-scss-module__Ft2KZa__button-primary-text",
  "button-text": "DoctorsSlider-module-scss-module__Ft2KZa__button-text",
  "button2-text": "DoctorsSlider-module-scss-module__Ft2KZa__button2-text",
  "card-shadow": "DoctorsSlider-module-scss-module__Ft2KZa__card-shadow",
  "doctors__card": "DoctorsSlider-module-scss-module__Ft2KZa__doctors__card",
  "doctors__head": "DoctorsSlider-module-scss-module__Ft2KZa__doctors__head",
  "doctors__navButtons": "DoctorsSlider-module-scss-module__Ft2KZa__doctors__navButtons",
  "doctors__showAllButton": "DoctorsSlider-module-scss-module__Ft2KZa__doctors__showAllButton",
  "doctors__slider": "DoctorsSlider-module-scss-module__Ft2KZa__doctors__slider",
  "doctors__title": "DoctorsSlider-module-scss-module__Ft2KZa__doctors__title",
  "effect-menu": "DoctorsSlider-module-scss-module__Ft2KZa__effect-menu",
  "header-1": "DoctorsSlider-module-scss-module__Ft2KZa__header-1",
  "main-container": "DoctorsSlider-module-scss-module__Ft2KZa__main-container",
  "main-footer-container": "DoctorsSlider-module-scss-module__Ft2KZa__main-footer-container",
  "main-header-container": "DoctorsSlider-module-scss-module__Ft2KZa__main-header-container",
  "txt-12-bold": "DoctorsSlider-module-scss-module__Ft2KZa__txt-12-bold",
  "txt-14-bold": "DoctorsSlider-module-scss-module__Ft2KZa__txt-14-bold",
  "txt-14-bold-caps": "DoctorsSlider-module-scss-module__Ft2KZa__txt-14-bold-caps",
  "txt-14-med": "DoctorsSlider-module-scss-module__Ft2KZa__txt-14-med",
  "txt-16-bold": "DoctorsSlider-module-scss-module__Ft2KZa__txt-16-bold",
  "txt-16-med": "DoctorsSlider-module-scss-module__Ft2KZa__txt-16-med",
  "txt-18-bold": "DoctorsSlider-module-scss-module__Ft2KZa__txt-18-bold",
  "txt-18-medium": "DoctorsSlider-module-scss-module__Ft2KZa__txt-18-medium",
  "txt-18-medium-24": "DoctorsSlider-module-scss-module__Ft2KZa__txt-18-medium-24",
  "txt-24-semi": "DoctorsSlider-module-scss-module__Ft2KZa__txt-24-semi",
});
